export const style_list = {

    // Strona główna

    page: {
        flexDirection: 'column'
    },

    fullPageImage: {
        width: '100%',
        height: '100%',
    },

    // Spis treści

    contentsPageWrapper: {
        width: '100%',
        height: '100%',
        position: 'relative',
        zIndex: 1,
        display: 'flex',
        flexDirection: 'row',
    },

    contentPageTitleWrapper: {
        width: '100%',
        position: 'absolute',
        top: 50,
        left: 0,
        backgroundColor: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 3,
    },

    contentPageTitle: {
        fontFamily: 'roboto_bold',
        textTransform: 'uppercase',
        fontSize: 40,
    },

    contentPageSidePanel: {
        width: '12%',
        height: '100%',
        backgroundColor: '#ffff00',
        flexDirection: 'column',
    },

    contentPageSidePanelWhite: {
        display: 'block',
        width: '100%',
        height: '50px',
        backgroundColor: "#fff",
        marginTop: '50px',
    },

    contentPageSidePanelInnerWrapper: {
        marginTop: '30px',
    },

    contentPageSIdePanelLink: {
        width: '50px',
        display: 'block',
        margin: 'auto',
        marginTop: '2px',
        marginBottom: '22px',
    },

    contentPageSidePanelImage: {
        height: '50px',
        width: '50px',
    },

    // Główny panel

    contentPageMainPanel: {
        width: '88%',
        height: '100%',
        marginTop: '100px',
        padding: '30px',
        flexDirection: 'column',
    },

    contentPageMainPanelInnerWrapper: {
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
        marginBottom: '20px',
        height: '54px',
    },

    contentPageMainPanelLink: {
        textDecoration: 'none',
    },

    contentPageMainPanelTopRow: {
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottom: '1px dashed #000',
        paddingBottom: '2px',
    },

    contentPageMainPanelCategoryTitle: {
        fontFamily: 'roboto_bold',
        fontSize: 14,
        letterSpacing: '0.3px',
        color: '#000',
    },

    contentPageMainPanelCategoryPage: {
        fontFamily: 'roboto_bold',
        fontSize: 14,
        color: '#000',
    },

    contentPageMainPanelCategoryDescription: {
        fontFamily: 'roboto_medium',
        fontSize: 12,
        textAlign: 'justify',
        marginTop: '5px',
    },

    // Strona o firmie

    companyPage: {
        width: '100%',
        height: '100%',
        position: 'relative',
        zIndex: 2,
    },

    companyPageTextWrapper: {
        width: '100%',
        height: '100%',
        paddingTop: '110px',
        paddingLeft: '30px',
        paddingRight: '30px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },

    companyPageText: {
        fontFamily: 'roboto_bold', 
        fontSize: 14,
        textAlign: 'justify',
        textIndent: '30px',
        marginTop: '15px',
    },

    companyPageLinkWrapper:  {
        marginBottom: '10px',
        display: 'flex',
        alignItems: 'center',
    },

    companyPageLink: {
        textDecoration: 'none',
        width: '60%',
    },

    companyPageLinkText: {
        fontFamily: 'roboto_bold', 
        fontSize: 16,
        textAlign: 'center',
        textTransform: 'uppercase',
        color: '#000',
        letterSpacing: '2px',
    },

    fullPageBackground: {
        display: 'block',
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        zIndex: 1,
    },

    // Strona produktów - nowa

    productPage: {
        width: '100%',
        height: '100%',
        flexDirection: 'row',
    },

    // Panel boczny z kategoriami

    productPageSidePanel: {
        width: '12%',
        height: '100%',
        backgroundColor: '#ffff00',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
    },

    productPageSidePanelWrapper: {
        paddingTop: '10px',
        paddingBottom: '10px',
        width: '100%',
    },

    White: {
        backgroundColor: '#ffffff',
    },

    productPageSidePanelLink: {
        width: '50px',
        display: 'block',
        margin: 'auto',
    },

    productPageSidePanelImage: {
        height: '50px',
        width: '50px',
    },

    // Panel główny z produktami

    productPageMainPanel: {
        width: '88%',
        height: '100%',
        padding: '10px',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },

    productPageMainPanelTopContainer: {
        width: '100%',
        textAlign: 'center',
    },

    productPageMainPanelTopText: {
        fontFamily: 'roboto_bold', 
        fontSize: 15,
        textTransform: 'uppercase',
    },

    productPageMainPanelTopBorder: {
        width: '100%',
        height: '2px',
        backgroundColor: '#000',
        marginTop: '5px',
    },

    // Produkty

    productPageMainPanelProductContainer: {
        width: '100%',
        height: '100%',
        flexDirection: 'row',
        flexWrap: 'wrap',
    },

    singleProductContainer: {
        display: 'flex',
        flexBasis: '19%',
        marginLeft: '0.5%',
        marginRight: '0.5%',
        //marginTop: '0.75%',
        //marginBottom: '0.75%',
        flexDirection: 'column',
        alignItems: 'center',
        paddingBottom: '3px',
    },

    singleProductContainerNormal: {
        marginTop: '0.75%',
        marginBottom: '0.75%',
    },

    singleProductContainerLarge: {
        marginTop: '1.5%',
        marginBottom: '1.5%',
    },

    // Zdjęcie, tło i nazwa produktu

    productTopWrapper: {
        width: '100%',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },

    productImageWrapper: {
        width: '100%',
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },

    line_horizontal: {
        position: 'absolute',
        backgroundColor: '#ffff00',
    },

    line_vertical: {
        position: 'absolute',
        backgroundColor: '#ffff00',
    },

        //backgroundColor: '#f7f7e1',

    productImage: {
        width: '50px',
        height: '50px',
        marginTop: '2px',
        marginBottom: '2px',
        //backgroundColor: '#d3d3d3',
    },

    productNameOuterWrapper: {
        width: '100%',
        flexGrow: 1,
        justifyContent: 'center',
    },

    productNameWrapper: {
        width: '100%',
        minHeight: '30px',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#D3D3D3',
        marginBottom: '2px',
        padding: '2px',
    },

    productName: {
        width: '98%',
        wordWrap: 'break-word',  
        whiteSpace: 'normal',
        fontFamily: 'roboto_bold', 
        textAlign: 'center',
        textTransform: 'uppercase',
    },

    productNameNormal: {
        fontSize: 10,
        lineHeight: 1.1,
    },

    productNameSmall: {
        fontSize: 7,
        lineHeight: 1.2,
    },

    // Szczegółowe dane o produkcie

    productBottomWrapper: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        //border: '1px solid #000'
    },

    productBottomWrapperSmall: {
        minHeight: '30px',
    },

    productBottomWrapperMedium: {
        minHeight: '57px',
    },

    productBottomWrapperLarge: {
        minHeight: '85px',
    },

    productDetailsRowWrapper: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        paddingTop: '1px',
        paddingBottom: '1px',
    },
    /*
    productDetailsRowWrapperMoved: {
        //borderTop: '1px solid #ooo',
        //marginTop: '-1px',
        //paddingTop: '1px',
    },
    */
    productDetailsBorder: {
        width: '100%',
        height: '1px',
        backgroundColor: '#000',
    },

    productDetailsLeftColumn: {
        flexBasis: '35%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    productDetails: {
        fontFamily: 'roboto_medium', 
        fontSize: 9,
    },

    productDiameterImage: {
        width: '10px',
        height: '10px',
        marginRight: '2px',
    },

    productSizeImage: {
        width: '16px',
        height: '6px',
        marginRight: '2px',
    },

    productHeightImage: {
        width: '9px',
        height: '10px',
        marginRight: '2px',
    },

    productVolumeImage: {
        width: '16px',
        height: '10px',
        marginRight: '2px',
    },

    productTemperatureImage: {
        width: '16px',
        height: '10px',
        marginRight: '2px',
    },

    productQuantityImage: {
        width: '12px',
        height: '9px',
        marginRight: '2px',
    },

    productDetailsRightColumn: {
        flexBasis: '65%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    // Stopka

    productPageFooter: {
        borderTop: '1px solid #ddd',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        paddingTop: '5px',
    },

    footerText: {
        fontSize: 10,
    },

    footerTextSeparator: {
        marginLeft: '1px',
        marginRight: '1px',
    },





   

    
    

};

/*

// Strona tytułowa

    titleSection: {
        position: 'relative',
        width: '100%',
        height: '100%',
    },

    titleBackgroundImage: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: 3,
    },

    titleLogo: {
        position: 'absolute',
        width: 300,
        height: 155,
        right: 50,
        bottom: 125,
        zIndex: 1,
    },

    logoText: {
        position: 'absolute',
        width: 300,
        height: 120,
        right: 50,
        bottom: 150,
        zIndex: 1,
    },

    logoGraphic: {
        position: 'absolute',
        width: 180,
        height: 329,
        left: 20,
        bottom: 110,
        zIndex: 1,
    },

    titleYear: {
        position: 'absolute',
        left: 240,
        top: 410,
        fontFamily: 'roboto_bold', 
        fontSize: 60,
        color: '#fdfddb',
    },

    // Spis treści

    listOuterContainer: {
        padding: 25,
        width: '100%',
        height: '100%',
        flexDirection: 'column',
    },

    listTitle: {
        textAlign: 'center',
        fontFamily: 'roboto_mono_italic', 
        fontSize: 24,
        marginTop: 25,
        marginBottom: 50,
    },

    listInnerContainer: {
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
    },

    listLink: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '80%',
        fontSize: 14,
        color: '#000',
        textDecoration: 'none',
        borderBottom: '2px dotted #000',
        marginBottom: 10,
    },

    listText: {
        fontSize: 14,
        fontFamily: 'roboto_mono_italic',
        paddingBottom: 2,
    },

    listPage: {
        fontSize: 14,
        fontFamily: 'roboto_bold', 
    },

    // Strony tytułowe kategorii

    categoryFrontPage: {
        flexDirection: 'column'
    },

    mainSection: {
        position: 'relative',
        width: '100%',
        height: '100%',
    },

    siteBackgroundImage: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: 3,
    },

    mainCategoryContainer: {
        padding: 25,
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },

    categoryMainImage: {
        maxWidth: '200px',
        maxHeight: '200px',
    },

    categoryMainTitle: {
        textAlign: 'center',
        fontFamily: 'roboto_mono_italic', 
        fontSize: 24,
        marginBottom: 20,
    },

    categoryMainDescription: {
        fontFamily: 'roboto_mono_italic', 
        fontSize: 14,
        textAlign: 'justify',
        hyphenationCallback: null,
    },

    // Strony z produktami

    productPageMainContainer: {
        width: '100%',
        height: '100%',
        padding: 25,
        flexDirection: 'row',
        justifyContent: 'space-between',
    },

    sidePanel: {
        width: '10%',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
    },

    sidePanelLink: {
        width: '50px',
    },

    sidePanelImage: {
        width: '50px',
    },

    sidePanelSeparator: {
        fontFamily: 'roboto_bold', 
        fontSize: 16,
        textAlign: 'center',
    },

    categoryTitle: {
        fontFamily: 'roboto_mono_italic',
        fontSize: 16,
        textAlign: 'right',
        borderBottom: '1px solid #000',
        marginBottom: 5,
        paddingBottom: 3,
    },

    mainPanel: {
        width: '89%',
        height: '96%',
        flexDirection: 'column',
    },

    productSection: {
        width: '100%',
        height: '100%',
        flexDirection: 'row',
        flexWrap: 'wrap',
        borderBottom: '1px solid #000',
    },

    productContainer: {
        //backgroundColor: '#eee',
        flexBasis: '18%',
        marginLeft: '1%',
        marginRight: '1%',
        marginTop: '1.5%',
        marginBottom: '1.5%',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },

    productImage: {
        width: '95%',
    },

    productNameContainer: {
        minHeight: 24,
        marginBottom: 3,
    },

    productName: {
        fontFamily: 'roboto_bold', 
        fontSize: 10,
    },

    productNumber: {
        fontFamily: 'roboto_mono_italic',
        textTransform: 'uppercase',
        fontSize: 10,
        width: '90%',
        padding: 1,
        backgroundColor: '#444',
        color: '#fff',
        textAlign: 'center',
    },

    barcodeContainer: {
        width: '95%',
        paddingTop: 3,
        marginTop: -1,
        backgroundColor: '#fff',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },

    barcodeImage: {
        width: '95%',
    },

    barcodeTextContainer: {
        width: '95%',
        backgroundColor: '#fff',
    },

    barcodeText: {
        fontSize: 10,
        textAlign: 'center',
        marginTop: -3,
        paddingBottom: 3,
    },

    // Stopka

    footer: {
        position: 'absolute',
        width: '100%',
        bottom: 10,
        
    },

    footerText: {
        margin: 2,
        fontSize: 12,
        textAlign: 'center',
    },

    // Pozostałości

    titleText: {
        position: 'absolute',
        left: 20,
        top: 240,
        fontFamily: 'roboto_bold', 
        fontSize: 45,
        color: '#000000',
        zIndex: 1,
    },

    titleTextUnder: {
        position: 'absolute',
        left: 25,
        top: 240,
        fontFamily: 'roboto_bold', 
        fontSize: 40,
        color: '#ffed00',
        zIndex: 1,
    },

    title: {
      fontSize: 24,
      marginBottom: 10
    },

    text: {
      fontSize: 10
    },


*/